export const resolveExpenseFeeStatusCategory = (row) => {
  const statusCode = String(
    row?.payment_type?.code
    || row?.payment_type_code
    || row?.status_code
    || row?.status_key
    || ''
  ).trim().toLowerCase();

  const statusLabel = String(row?.status || row?.status_name || '').trim().toLowerCase();

  if (statusCode.includes('cancel') || statusLabel.includes('cancel')) {
    return 'canceled';
  }

  if (statusCode.includes('done') || statusLabel.includes('pagad') || statusLabel.includes('paid')) {
    return 'paid';
  }

  if (statusCode.includes('pend') || statusLabel.includes('pend') || statusLabel.includes('pronostic')) {
    return 'pending';
  }

  return 'pending';
};

export const countExpenseFeeByStatus = (rows, statusKey) => {
  const safeRows = Array.isArray(rows) ? rows : [];
  return safeRows.filter((row) => resolveExpenseFeeStatusCategory(row) === statusKey).length;
};

export const buildExpenseFeeStatusTabs = (rows) => {
  const safeRows = Array.isArray(rows) ? rows : [];

  return [
    { key: 'all', label: 'Todos', count: safeRows.length, showCount: true },
    { key: 'pending', label: 'Pendiente', count: countExpenseFeeByStatus(safeRows, 'pending'), showCount: true },
    { key: 'paid', label: 'Pagado', count: countExpenseFeeByStatus(safeRows, 'paid'), showCount: true },
    { key: 'canceled', label: 'Cancelado', count: countExpenseFeeByStatus(safeRows, 'canceled'), showCount: true },
  ];
};

export const filterExpenseFeeByStatus = (rows, activeStatusTab) => {
  const safeRows = Array.isArray(rows) ? rows : [];
  if (activeStatusTab === 'all') {
    return safeRows;
  }

  return safeRows.filter((row) => resolveExpenseFeeStatusCategory(row) === activeStatusTab);
};
